

<!-- Toolbar -->
<div class="mains " [ngStyle]="{'background-color':color.PrimaryColor}" >
    <div class="toolbar" role="banner" [ngStyle]="{'background-color':color.headerColor}" style="min-width: 1200px;">
      <div class="logo-container-main" style="cursor: pointer;" (click)="onlogoClick()">
        <!-- <img src="../../../assets/images/NewGilpinLogo.jpeg" alt="" width="80px"> -->

        <div style="font-family: cursive;font-weight: bold;" class="logo"></div>
      </div>
      <span class="tooolbar-seperator"></span> 
     <!-- <mat-icon class="pointer" (click)="sidebar()">double_arrow</mat-icon> -->

     <div *ngIf="parentUser"  class="pt-2 pointer" style="z-index: 2;"><mat-icon (click)="switchBack()">settings_backup_restore</mat-icon></div>&nbsp;
     <button *ngIf="isActive('/app/flight-intl-list')&&tripEnable===true||isActive('/app/flightList')&&tripEnable===true||isActive('/app/hotellist')&&tripEnable===true ||isActive('/app/flightlist')&&tripEnable===true" mat-menu-item (click)="onClickTrip(username)" style="width: 130px;"><mat-icon style="color:white">trip_origin</mat-icon> TRIP</button>

     <div *ngIf="!isActive('/app/flight-intl-list')&&!isActive('/app/flightList')&&!isActive('/app/hotellist') &&!isActive('/app/flightlist') && userType==='CORPORATE' ||!isActive('/app/flight-intl-list')&&!isActive('/app/flightList')&&!isActive('/app/hotellist') && !isActive('/app/flightlist') && userType==='STAFF'">Switch Account</div>
    
   <div *ngIf="!isActive('/app/flight-intl-list')&&!isActive('/app/flightList')&&!isActive('/app/hotellist') &&!isActive('/app/flightlist') && userType==='CORPORATE' ||!isActive('/app/flight-intl-list')&&!isActive('/app/flightList')&&!isActive('/app/hotellist') && !isActive('/app/flightlist') && userType==='STAFF'" style="padding-left: 10px; ">
     <form   class="example-form"  >
        <!-- <mat-chip-grid #chipGrids aria-label="city Selection">
      </mat-chip-grid> -->
     
        <input style="color: white; font-size: 15px;border-bottom: solid;border-left: none ;border-right: none; border-top: none;
        outline:none;
        background-color: transparent;"
        [formControl]="ToCtrl"
        (blur)="hideSuggestions()"
    (focus)="showSuggestions();"
        >
        <ul *ngIf="isSuggestionsVisible" style="list-style: none; padding: 0; margin: 0; position: absolute; background-color: #064972f1; width: 40%; max-height: 180px; overflow-y: auto; border-radius:4px">
          <li  class="col-md-12 emulateHover"
          (click)="selectedTo(user)"
            *ngFor="let user of filteredTo| async;let i=index">
            <small    >{{user.name}}, {{user?.userType}}</small>
          </li>
        </ul>
      <!-- <mat-autocomplete  #autoTo="matAutocomplete" >
        <mat-option  *ngFor="let user of filteredTo | async" [value]="user.name"   class="mat-primary" >
          <small style="font-size: x-small;">{{user.name}}, {{user?.userType}}</small>
        </mat-option>
        
      </mat-autocomplete> -->

      
    </form></div>
    <mat-icon >
    </mat-icon>
    <mat-icon *ngIf="!isActive('/app/flight-intl-list')&&!isActive('/app/flightList')&&!isActive('/app/hotellist') &&!isActive('/app/flightlist') && userType==='CORPORATE' ||!isActive('/app/flight-intl-list')&&!isActive('/app/flightList')&&!isActive('/app/hotellist') &&!isActive('/app/flightlist') && userType==='STAFF'" (click)="EmulateUser()" class="pointer">forward</mat-icon>

         <span *ngIf="isActive('/app/flight-intl-list')||isActive('/app/flightList')||isActive('/app/flightlist')||isActive('/app/hotellist')"> <app-booking-menu-list *ngIf="!tripEnable" style="font-size: 12px;"></app-booking-menu-list></span>

    <!-- <div *ngIf="isActive('/app/flightlist')" class="outside-container  mainDivFlight" style="position: absolute; top:45%;right:23%;">
      <div class=" col-md-10" style="background-color:#361F30;border-radius: 0px;">
              <div class="container">
<app-booking-menu-list style="font-size: 12px;"></app-booking-menu-list>
</div> 
</div>
</div> -->
      <div class="toolbar-company-container">
       <!--<app-toolbar-company></app-toolbar-company>-->
       <div class="col-md-12 d-flex justify-content-center " >
        <!-- <p-button [style]="{ width: '10rem',height:'2.9rem' }" (onClick)="showDialog()" label="Add Amount" /> -->
        
        <p-dialog 
            header="Amount" 
            [modal]="true"
            [(visible)]="visible" 
            [style]="{ width: '50rem',height:'30rem' }" 
            [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
            [maximizable]="true">
            <div class="flex flex-column gap-2 ">
              <label for="enterAmount">Enter Amount</label>
              <input 
              type="text"

                  pInputText 
                  [(ngModel)]="amount"
                  aria-describedby="username-help" 
                  (keypress)="onlyNumberKey($event)"
                   />

              <small >
                 to go to the Payment Page
                 
              </small>
          </div>
          <div class="flex flex-column gap-2 ">
            <img src="/assets/images/Add_24.gif" width="350px" height="250px" alt="">

            <button class="stylish-button" (click)="initiatePayment()" [disabled]="!amount">Pay Now</button>

          </div>
        </p-dialog>
        
       </div> 
       
      </div>
      <!-- <div *ngIf="tripEnable===true&&tripResponse&&isActive('/app/flight')||tripEnable===true&&tripResponse&&isActive('/app/hotel')" >
      <span style="font-weight: 500;">Select Trip - {{tripResponse?.tripUid}}&nbsp; &nbsp;  Name : {{tripResponse?.tripName}} </span>
      <span style="padding-right: 8px;">  <button  mat-flat-button (click)="onClickQTGTrip()" style="font-size: 14px;">View Trip</button></span>
    </div> -->
      <div *ngIf="userType==='CORPORATE'||userType==='AGENT'" style="margin-right: 10px; white-space: nowrap;">
        <span *ngIf="totalBalance?.hasOwnProperty('totalDepositAmount')"style="color: white; font-size: smaller;"> <strong>Advance :</strong> &nbsp;{{totalBalance?.totalDepositAmount?(totalBalance?.totalDepositAmount+' INR'):'0 INR'}}</span><br>
        <span *ngIf="totalBalance?.hasOwnProperty('totalCreditAmount')" style="color: white;font-size: smaller;"> <strong>Credit : </strong> &nbsp;{{totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount+' INR'):'0 INR'}}</span></div>
      <!-- <div *ngIf="userType==='STAFF'||userType==='CORPORATE'" style="margin-right: 10px; " ><mat-slide-toggle #slideToggle [(ngModel)]="stoggle"   (click)="openPopup()"><span style="color: white;">Admin Mode</span></mat-slide-toggle></div> -->
      <span class="tooolbar-seperator"></span>

      <mat-icon class="pointer" style="margin-left:7px;margin-right: 12px;" (click)="terminalClick()">terminal</mat-icon>

      <span class="tooolbar-seperator"></span>
     <span style="padding-right: 10px;cursor: pointer;" [matMenuTriggerFor]="menu" Style="color: white;"> <small class="mt-3"> <mat-icon class="pt-1">person</mat-icon>  {{displayname}}</small></span>
<mat-menu #menu="matMenu"  >
  <!-- <button   mat-menu-item (click)="openfullscreen()" style="width: 200px;" id="fullscreenButton"><mat-icon>person</mat-icon>Full Screen</button>
  <button   mat-menu-item (click)="exitFullScreen()" style="width: 200px;"><mat-icon>person</mat-icon>Exit Full Screen</button> -->

  <button   mat-menu-item (click)="UpdateUser(username)" style="width: 200px;"><mat-icon>person</mat-icon> User Profile</button>
  <button *ngIf="menuItems.manualCart" mat-menu-item  style="width: 200px;" (click)="onCreateCart(username)"><mat-icon>note_add</mat-icon>Manual Cart</button>
  <button  mat-menu-item  style="width: 200px;" (click)="onClickCart(username)"><mat-icon>pending_actions</mat-icon>Manage Carts</button>
  <button  mat-menu-item  style="width: 200px;" (click)="onClickCalendar(username)"><mat-icon>calendar_today</mat-icon>Air Booking Calendar</button>
  <button *ngIf="menuItems.adminMode" mat-menu-item (click)="openPopup()"><mat-icon>admin_panel_settings</mat-icon>Admin Mode</button>
  <button  mat-menu-item (click)="aisedTicket()"><mat-icon>local_activity</mat-icon>Raise Issue</button>
  <button *ngIf="menuItems.aiDashboard" mat-menu-item (click)="onClickAgentDash()"  ><mat-icon>dashboard</mat-icon>Dashboard</button>
  <button *ngIf="tripEnable===true" mat-menu-item (click)="onClickTrip(username)"><mat-icon>trip_origin</mat-icon> TRIP</button>
  <button *ngIf="tripEnable===true" mat-menu-item (click)="onClickExpense()"><mat-icon>library_books</mat-icon>Expenses</button>

  <!-- <button *ngIf="userType==='CORPORATE'" mat-menu-item (click)="onClickTrip(username)"><mat-icon>download</mat-icon>Travel Policy</button> -->

  <!-- <button *ngIf="userType==='CORPORATE'" mat-menu-item (click)="onClickTrip(username)"><mat-icon>download</mat-icon>SOP</button> -->

  <button *ngIf="userType==='AGENT'"  mat-menu-item (click)="showDialog()" ><mat-icon>payment</mat-icon>Add Amount</button>
  <!--  -->
  <button mat-menu-item  (click)="manageFile()"><mat-icon>cloud_upload</mat-icon>Manage File Upload</button>

  <button mat-menu-item (click)="signOut()" ><mat-icon>logout</mat-icon>Signout</button>
</mat-menu>
      <!-- <app-signin-user></app-signin-user> -->
  <!-- <span class="tooolbar-seperator"></span> 
    <app-notification></app-notification>-->
      <span class="tooolbar-seperator"></span> 
      <!-- <app-module-menu></app-module-menu>-->
    </div>
    <div class="col-md-12">

     
    </div>
    <div class="col-md-12 content" role="main">
      
     
      
      <div class="content-page column zoomINN">
        <router-outlet ></router-outlet>
      </div>
    
      <!-- Footer -->
      <footer>
      </footer>
    </div>
  </div>
  <!--<div (click)="closePopup()" class="modal " id="myMod" [style.display]="ispopupthide ? 'block' : 'none'" >
    <div class="modal-dialog " >
      <div class="modal-content " >
        <div class="modal-header ">
          <h4 class="modal-title"></h4>
          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
        </div>
        <div class="modal-body">
          <div class="link " ><ul><li><a   routerLink="/app/flight" routerLinkActive="active" (click)="hideNav('flight')"  >Bookings</a></li></ul></div> 
          <div class="link " ><ul><li><a   routerLink="/app/settings" routerLinkActive="active" (click)="hideNav('settings')" >Settings</a></li></ul></div> 
  
  
         
  
        </div>
      </div>-->
     